// extracted by mini-css-extract-plugin
export default {"price":"G7-z","onSale":"H7-z","msrpLabelPrice":"I7-z","msrpLabel":"J7-z","originalPrice":"K7-z","percentOff":"L7-z"};